/* K2 – Veličina i Boja iz opcija proizvoda (dok Search & Discovery filteri nisu uključeni).
   Parametri k_velicina / k_boja idu u URL preko postojeće forme filtera; ovde se mreža filtrira u pregledaču. */
(() => {
  if (window.eliaKolekcijaFilteri) return;
  window.eliaKolekcijaFilteri = true;

  const SIZE = /^(size|veli[čc]ina)$/i;
  const COLOR = /^(colou?r|boja)$/i;
  let productData = null;
  let running = false;

  const params = () => {
    const sp = new URLSearchParams(location.search);
    return { velicina: sp.getAll('k_velicina'), boja: sp.getAll('k_boja') };
  };

  const word = n => {
    const host = document.querySelector('elia-collection-filters');
    const one = host?.dataset.kOne || 'proizvod', many = host?.dataset.kMany || 'proizvoda';
    return n % 10 === 1 && n % 100 !== 11 ? one : many;
  };

  async function loadProducts() {
    if (productData) return productData;
    const base = location.pathname.replace(/\/$/, '');
    const map = {};
    for (let page = 1; page < 20; page++) {
      const res = await fetch(`${base}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const { products = [] } = await res.json();
      products.forEach(p => {
        const sizeIdx = p.options.findIndex(o => SIZE.test(o.name));
        const colorIdx = p.options.findIndex(o => COLOR.test(o.name));
        const sizes = new Set(), colors = new Set();
        let price = Infinity;
        p.variants.forEach(v => {
          const opt = i => v[`option${i + 1}`];
          if (sizeIdx > -1 && v.available) sizes.add(opt(sizeIdx));
          if (colorIdx > -1) colors.add(String(opt(colorIdx)).toLowerCase());
          price = Math.min(price, parseFloat(v.price));
        });
        map[p.handle] = { sizes, colors, price };
      });
      if (products.length < 250) break;
    }
    return (productData = map);
  }

  // K3: jedna lista proizvoda i jedno stanje stranica za automatsko učitavanje (Alo) i za filtere.
  let pending = null;
  let pagesLoaded = 1;
  let io = null;
  const moreBox = () => document.querySelector('#ProductGridContainer [data-k3-more]');
  const filtersActive = () => { const s = params(); return s.velicina.length + s.boja.length > 0; };

  function loadNext() {
    if (pending) return pending;
    const box = moreBox();
    const list = document.querySelector('#ProductGridContainer #product-grid');
    if (!box || !list) return Promise.resolve(false);
    pending = (async () => {
      const link = box.querySelector('.elia-k3-more__link');
      const error = box.querySelector('.elia-k3-error');
      box.classList.add('is-loading');
      if (error) error.hidden = true;
      try {
        const url = new URL(link.href, location.href);
        const section = document.querySelector('elia-collection-filters')?.dataset.section;
        if (section) url.searchParams.set('section_id', section);
        const res = await fetch(url.href);
        if (!res.ok) throw new Error('request');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const seen = new Set([...list.children].map(handleOf));
        const items = [...doc.querySelectorAll('#product-grid > li')].filter(li => !seen.has(handleOf(li)));
        if (filtersActive()) items.forEach(li => (li.hidden = true));
        list.append(...items);
        pagesLoaded++;
        const next = doc.querySelector('[data-k3-more] .elia-k3-more__link');
        if (next) {
          const n = new URL(next.getAttribute('href'), location.href);
          n.searchParams.delete('section_id');
          link.href = n.pathname + n.search;
        } else { box.remove(); updateEnd(); }
        const status = document.querySelector('#ProductGridContainer [data-k3-status]');
        if (status) status.textContent = `Dodato ${items.length} ${word(items.length)}. Prikazano ${list.children.length}.`;
        return true;
      } catch (e) {
        if (error) error.hidden = false;
        return false;
      } finally {
        box.classList.remove('is-loading');
        pending = null;
      }
    })();
    return pending;
  }

  // Brže: kad je filter uključen, sve preostale stranice učitaj odjednom (paralelno), pa ih dodaj redom.
  async function loadAll() {
    if (pending) await pending;
    const box = moreBox();
    const list = document.querySelector('#ProductGridContainer #product-grid');
    const link = box?.querySelector('.elia-k3-more__link');
    const from = Number(new URL(link?.href || location.href, location.href).searchParams.get('page'));
    const last = Number(box?.dataset.k3Pages);
    if (!box || !list || !from || !last || last < from) { while (moreBox()) if (!(await loadNext())) break; return; }
    const section = document.querySelector('elia-collection-filters')?.dataset.section;
    const pages = [];
    for (let n = from; n <= last; n++) {
      const url = new URL(link.href, location.href);
      url.searchParams.set('page', n);
      if (section) url.searchParams.set('section_id', section);
      pages.push(fetch(url.href).then(r => (r.ok ? r.text() : Promise.reject(r.status))));
    }
    box.classList.add('is-loading');
    try {
      const texts = await Promise.all(pages);
      const seen = new Set([...list.children].map(handleOf));
      texts.forEach(t => {
        const doc = new DOMParser().parseFromString(t, 'text/html');
        doc.querySelectorAll('#product-grid > li').forEach(li => {
          const h = handleOf(li);
          if (seen.has(h)) return;
          seen.add(h);
          if (filtersActive()) li.hidden = true;
          list.append(li);
        });
      });
      pagesLoaded = last;
      box.remove();
      updateEnd();
    } catch (e) {
      box.classList.remove('is-loading');
      while (moreBox()) if (!(await loadNext())) break;
    }
  }

  function arm() {
    io?.disconnect();
    const box = moreBox();
    if (!box) return;
    if (!box.dataset.k3Bound) {
      box.dataset.k3Bound = '1';
      box.querySelector('.elia-k3-more__link').addEventListener('click', e => { e.preventDefault(); loadNext().then(arm); });
      box.addEventListener('click', e => { if (e.target.closest('[data-k3-retry]')) loadNext().then(arm); });
    }
    if (box.dataset.k3Auto === 'false') return;
    box.classList.add('is-auto');
    io = new IntersectionObserver(entries => {
      if (entries.some(en => en.isIntersecting) && !filtersActive()) loadNext().then(ok => ok && arm());
    }, { rootMargin: '0px 0px 800px 0px' });
    io.observe(box);
    nearEnd();
  }

  // Rezerva uz IntersectionObserver: provera pri skrolu.
  function nearEnd() {
    const box = moreBox();
    if (!box || pending || filtersActive() || !box.classList.contains('is-auto')) return;
    if (!box.querySelector('.elia-k3-error')?.hidden) return;
    if (box.getBoundingClientRect().top < innerHeight + 800) loadNext().then(ok => ok && arm());
  }
  let scrollTick = false;
  window.addEventListener('scroll', () => {
    if (scrollTick) return;
    scrollTick = true;
    setTimeout(() => { scrollTick = false; nearEnd(); }, 150);
  }, { passive: true });

  // Povratak sa proizvoda: iste učitane serije i isto mesto na stranici.
  const restoreKey = () => 'k3:' + location.pathname + location.search;
  window.addEventListener('pagehide', () => {
    try { sessionStorage.setItem(restoreKey(), JSON.stringify({ pages: pagesLoaded, y: scrollY })); } catch (e) {}
  });
  async function restore() {
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(restoreKey()) || 'null'); sessionStorage.removeItem(restoreKey()); } catch (e) {}
    const nav = performance.getEntriesByType?.('navigation')[0];
    if (!saved || saved.pages < 2 || nav?.type !== 'back_forward') return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    for (let i = 1; i < saved.pages; i++) if (!(await loadNext())) break;
    arm();
    scrollTo(0, saved.y);
  }

  function handleOf(item) {
    const a = item.querySelector('a[href*="/products/"]');
    return a ? new URL(a.href, location.href).pathname.split('/products/')[1]?.split(/[/?#]/)[0] : null;
  }

  function syncControls(state) {
    const host = document.querySelector('elia-collection-filters');
    if (!host) return;
    const colorRaw = {};
    host.querySelectorAll('[data-k-input]').forEach(input => {
      input.checked = state[input.dataset.kInput].includes(input.value);
      if (input.dataset.kRaw) colorRaw[input.dataset.kRaw.toLowerCase()] = input.value;
    });
    host.querySelectorAll('[data-k-pill]').forEach(pill => {
      const n = state[pill.dataset.kPill].length;
      pill.textContent = pill.dataset.kPill === 'velicina' ? (host.dataset.kSizeLabel || 'Veličina') : (host.dataset.kColorLabel || 'Boja');
      if (n) pill.textContent += ` (${n})`;
    });
    document.querySelectorAll('elia-collection-filters .filter-selected, [data-k2-chips]').forEach(chips => {
      chips.querySelectorAll('[data-k-chip]').forEach(c => c.remove());
      const add = (key, value) => {
        const url = new URL(location.href);
        const rest = url.searchParams.getAll(key).filter(v => v !== value);
        url.searchParams.delete(key);
        rest.forEach(v => url.searchParams.append(key, v));
        const a = document.createElement('a');
        a.href = url.pathname + url.search;
        a.dataset.filterRemove = '';
        a.dataset.kChip = '';
        a.setAttribute('aria-label', `Ukloni filter: ${value}`);
        a.textContent = `${value} `;
        const x = document.createElement('span');
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        a.append(x);
        chips.prepend(a);
      };
      state.boja.slice().reverse().forEach(v => add('k_boja', v));
      state.velicina.slice().reverse().forEach(v => add('k_velicina', v));
      if (state.velicina.length + state.boja.length && !chips.querySelector('.clear-all')) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'clear-all';
        clear.dataset.filterReset = '';
        clear.textContent = host.dataset.kClear || 'Obriši sve';
        chips.append(clear);
      }
    });
    const mine = state.velicina.length + state.boja.length;
    const title = host.querySelector('.filter-heading h2');
    if (title) {
      if (title.dataset.kBase == null) title.dataset.kBase = (title.textContent.match(/\((\d+)\)/) || [0, 0])[1];
      title.textContent = `${host.dataset.kTitle || 'Izabrani filteri'} (${Number(title.dataset.kBase) + mine})`;
    }

    return colorRaw;
  }

  async function apply() {
    if (running) return;
    running = true;
    try {
      const state = params();
      const colorRaw = syncControls(state) || {};
      const grid = document.getElementById('ProductGridContainer');
      if (!grid) return;
      const items = [...grid.querySelectorAll('#product-grid > li')];
      const active = state.velicina.length || state.boja.length;
      if (!active) {
        items.forEach(li => (li.hidden = false));
        grid.querySelector('[data-k-empty]')?.remove();
        return;
      }
      grid.setAttribute('aria-busy', 'true');
      const [data] = await Promise.all([loadProducts(), loadAll()]);
      let shown = 0;
      grid.querySelectorAll('#product-grid > li').forEach(li => {
        const info = data[handleOf(li)];
        const okSize = !state.velicina.length || (info && state.velicina.some(s => info.sizes.has(s)));
        const okColor = !state.boja.length || (info && [...info.colors].some(c => state.boja.includes(colorRaw[c] || c)));
        li.hidden = !(okSize && okColor);
        if (!li.hidden) shown++;
      });
      document.querySelectorAll('.k3-info .collection-count, [data-k3-count-top]').forEach(c => (c.textContent = `${shown} ${word(shown)}`));
      updateEnd(shown);
      let empty = grid.querySelector('[data-k-empty]');
      if (!shown && !empty) {
        empty = document.createElement('p');
        empty.dataset.kEmpty = '';
        empty.className = 'elia-k2-empty';
        empty.textContent = document.querySelector('[data-k3-empty-text]')?.dataset.k3EmptyText || 'Nema proizvoda za izabrane filtere.';
        grid.append(empty);
      } else if (shown && empty) empty.remove();
      grid.removeAttribute('aria-busy');
    } finally {
      running = false;
    }
  }

  // Alo-stil padajući meni za sortiranje na računaru (umesto sistemskog menija pregledača).
  function buildSort() {
    const wrap = document.querySelector('elia-collection-filters .collection-tools-right');
    const select = wrap?.querySelector('select[data-toolbar-sort]');
    if (!wrap || !select || wrap.querySelector('.k-sort-btn')) return;
    wrap.classList.add('k-sort-ready');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'k-sort-btn';
    btn.textContent = 'Sortiraj';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    const list = document.createElement('ul');
    list.className = 'k-sort-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Sortiraj');
    list.hidden = true;
    [...select.options].forEach(o => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = o.value;
      li.textContent = o.textContent;
      li.setAttribute('aria-selected', String(o.selected));
      list.append(li);
    });
    const items = () => [...list.children];
    const close = focus => { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus(); };
    const open = () => {
      list.hidden = false; btn.setAttribute('aria-expanded', 'true');
      (items().find(i => i.getAttribute('aria-selected') === 'true') || items()[0]).focus();
    };
    const choose = li => {
      close(true);
      if (select.value === li.dataset.value) return;
      select.value = li.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    btn.addEventListener('click', () => (list.hidden ? open() : close(false)));
    list.addEventListener('click', e => { const li = e.target.closest('[role=option]'); if (li) choose(li); });
    list.addEventListener('keydown', e => {
      const all = items(), i = all.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); all[Math.min(i + 1, all.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); all[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (all[i]) choose(all[i]); }
      else if (e.key === 'Escape' || e.key === 'Tab') close(e.key === 'Escape');
    });
    document.addEventListener('click', e => { if (!wrap.contains(e.target)) close(false); });
    wrap.append(btn, list);
  }

  // K2c: broj na dugmetu „Prikaži N proizvoda” i zasivljene opcije, iz trenutnog (nepotvrđenog) izbora u panelu.
  async function preview() {
    const host = document.querySelector('elia-collection-filters');
    const form = host?.querySelector('form');
    const button = host?.querySelector('[data-k2-apply]');
    if (!form || !button) return;
    const data = await loadProducts();
    const checked = kind => [...form.querySelectorAll(`[data-k-input="${kind}"]:checked`)].map(i => i.value);
    const rawToName = {};
    form.querySelectorAll('[data-k-input="boja"]').forEach(i => { if (i.dataset.kRaw) rawToName[i.dataset.kRaw.toLowerCase()] = i.value; });
    const sizes = checked('velicina'), colors = checked('boja');
    const lo = parseFloat(form.querySelector('[data-price-min]')?.value), hi = parseFloat(form.querySelector('[data-price-max]')?.value);
    const okSize = (p, list) => !list.length || list.some(v => p.sizes.has(v));
    const okColor = (p, list) => !list.length || [...p.colors].some(c => list.includes(rawToName[c] || c));
    const okPrice = p => (isNaN(lo) || p.price >= lo) && (isNaN(hi) || p.price <= hi);
    const products = Object.values(data);
    const n = products.filter(p => okSize(p, sizes) && okColor(p, colors) && okPrice(p)).length;
    button.textContent = `${host.dataset.kApply || 'Prikaži'} ${n} ${word(n)}`;
    button.disabled = n === 0;
    form.querySelectorAll('[data-k-input="velicina"]').forEach(i => {
      const has = i.checked || products.some(p => p.sizes.has(i.value) && okColor(p, colors) && okPrice(p));
      i.disabled = !has;
    });
    form.querySelectorAll('[data-k-input="boja"]').forEach(i => {
      const has = i.checked || products.some(p => okSize(p, sizes) && okPrice(p) && [...p.colors].some(c => (rawToName[c] || c) === i.value));
      i.disabled = !has;
    });
  }
  document.addEventListener('k2:preview', () => { preview(); });

  // K3: kraj liste („Prikazano svih N”) i „Na vrh”.
  function updateEnd(n) {
    const end = document.querySelector('[data-k3-end]');
    if (!end) return;
    const visible = n ?? [...document.querySelectorAll('#product-grid > li')].filter(li => !li.hidden).length;
    end.hidden = !!moreBox() || visible === 0;
    const text = end.querySelector('[data-k3-end-text]');
    if (text) text.textContent = (end.dataset.k3Tpl || 'Prikazani su svi proizvodi ([n])').replace('[n]', String(visible));
  }
  document.addEventListener('click', e => {
    const top = e.target.closest('[data-k3-top]');
    if (top) {
      e.preventDefault();
      // Lepljiva traka uvek „stoji” na vrhu, pa se meri njen roditelj (početak oblasti mreže).
      const bar = document.querySelector('[data-k3-bar]')?.parentElement || document.getElementById('ProductGridContainer');
      const header = document.querySelector('.section-header');
      const offset = header ? Math.max(0, header.getBoundingClientRect().height) : 0;
      scrollTo({ top: bar.getBoundingClientRect().top + scrollY - offset, behavior: 'smooth' });
      return;
    }
    // Oznake izabranog iznad mreže (van trake): uklanjanje i „Obriši sve”.
    const host = document.querySelector('elia-collection-filters');
    const remove = e.target.closest('[data-k3-info] [data-filter-remove]');
    if (remove && host?.update && !e.metaKey && !e.ctrlKey) { e.preventDefault(); host.update(new URL(remove.href, location.href)); return; }
    if (e.target.closest('[data-k3-info] [data-filter-reset]') && host?.submitFilters) {
      host.form.querySelectorAll('input[type=checkbox]').forEach(i => (i.checked = false));
      host.form.querySelectorAll('input[type=number]').forEach(i => (i.value = ''));
      host.submitFilters();
    }
  });

  // K3: lepljiva traka ide tačno ispod headera dok je vidljiv; kad se header skloni, traka je na vrhu.
  function stickTop() {
    const bar = document.querySelector('[data-k3-bar].is-sticky');
    if (!bar) return;
    const header = document.querySelector('.section-header');
    let top = 0;
    if (header) { const r = header.getBoundingClientRect(); if (r.bottom > 0 && getComputedStyle(header).visibility !== 'hidden') top = Math.max(0, r.bottom); }
    bar.style.top = `${Math.round(top)}px`;
    bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1 && scrollY > 0);
  }
  let stickRaf = 0;
  let stickLate = 0;
  window.addEventListener('scroll', () => {
    cancelAnimationFrame(stickRaf); stickRaf = requestAnimationFrame(stickTop);
    // Header se pojavljuje/sklanja animirano – ponovo izmeri kad animacija završi.
    clearTimeout(stickLate); stickLate = setTimeout(stickTop, 320);
  }, { passive: true });
  document.addEventListener('transitionend', e => { if (e.target.closest?.('.section-header, sticky-header')) stickTop(); }, true);
  window.addEventListener('resize', stickTop);

  // Broj iznad trake (računar) prati broj iz mreže posle svakog osvežavanja.
  function syncTopCount() {
    const top = document.querySelector('[data-k3-count-top]');
    const src = document.querySelector('.k3-info .collection-count');
    if (top && src) top.textContent = src.textContent;
  }

  function watch() {
    const host = document.querySelector('elia-collection-filters');
    const grid = document.getElementById('ProductGridContainer');
    if (!host || !grid) return;
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      setTimeout(() => { queued = false; buildSort(); arm(); syncTopCount(); apply(); }, 0);
    };
    new MutationObserver(schedule).observe(host, { childList: true });
    new MutationObserver(m => { if (m.some(r => [...r.addedNodes].some(n => n.id === 'product-grid' || n.querySelector?.('#product-grid')))) { pagesLoaded = 1; schedule(); } }).observe(grid, { childList: true });
    window.addEventListener('popstate', schedule);
    buildSort();
    arm();
    apply();
    restore();
    // Podaci za filtere (veličine/boje) unapred, dok kupac gleda stranicu.
    (window.requestIdleCallback || (f => setTimeout(f, 1200)))(() => loadProducts().catch(() => {}));
    stickTop();
    updateEnd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
